<template>
  <w-icon-wrapper
    :width='24'
    :height='19.2'
    icon-name='work-nav-holidays-icon'
    view-box='0 0 24 19.2'
  >
    <path
      id="_13_Urlaub_Icon"
      data-name="13_Urlaub_Icon"
      d="M88.22-786.02l10.68-2.82a1.036,1.036,0,0,0,.675-.555,1.2,1.2,0,0,0,.105-.885,1.052,1.052,0,0,0-.525-.675,1.11,1.11,0,0,0-.855-.1l-2.94.78-4.8-4.5-1.68.42,2.88,5.04-2.88.72-1.5-1.14-1.14.3Zm13.38,5.22H82.4a2.311,2.311,0,0,1-1.695-.705A2.311,2.311,0,0,1,80-783.2V-788a2.311,2.311,0,0,0,1.695-.705,2.311,2.311,0,0,0,.705-1.7,2.311,2.311,0,0,0-.705-1.695A2.311,2.311,0,0,0,80-792.8v-4.8a2.311,2.311,0,0,1,.705-1.7A2.311,2.311,0,0,1,82.4-800h19.2a2.311,2.311,0,0,1,1.695.705,2.311,2.311,0,0,1,.705,1.7v14.4a2.311,2.311,0,0,1-.705,1.7A2.311,2.311,0,0,1,101.6-780.8Zm0-2.4v-14.4H82.4v3.06a4.919,4.919,0,0,1,1.755,1.755A4.615,4.615,0,0,1,84.8-790.4a4.615,4.615,0,0,1-.645,2.385A4.919,4.919,0,0,1,82.4-786.26v3.06ZM92-790.4Z"
      transform="translate(-80 800)"
      fill="currentColor"
    />
  </w-icon-wrapper>
</template>

<script>
export default { name: 'WorkIconNavHolidays' };
</script>

